import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, onUnmounted, ref, watch } from "vue";
import * as moment from "moment";
import { isArtemisTimeline, isOrionTelemetry, isOrionTelemetryDataAvailable, isServiceSuccess, OrionTelemetryDatapoint, ServiceResult } from '@/data.types';
import { dpTimeToDate } from '../data.functions';

interface Props {
  data: ServiceResult
  dataTimeline: ServiceResult
}

export default /*#__PURE__*/_defineComponent({
  __name: 'time-display',
  props: {
    data: null,
    dataTimeline: null
  },
  setup(__props: any) {

const props = __props as {
  data: ServiceResult
  dataTimeline: ServiceResult
};

function timeMCC(value: moment.Moment | null) {
  return value ? value.format("DDDD:HH:mm:ss") : "n/a";
}
function durationMCC(value: moment.Duration | null) {
  return value
    ? `${Math.sign(value.asMilliseconds()) < 0 ? '-' : ''}`
    + `${Math.abs(value.days())}:${Math.abs(value.hours()).toString().padStart(2, "0")}`
    + `:${Math.abs(value.minutes()).toString().padStart(2, "0")}`
    + `:${Math.abs(value.seconds()).toString().padStart(2, "0")}`
    : "n/a";
}



const gmt = ref<moment.Moment>(moment.utc());
const met = ref<moment.Duration | null>(null);
const metSource = ref<string>("STANDARD");
const timer = ref<number>();

watch(props, ({ data: val }) => {
  let constructedMET: { [key: string]: number | string | boolean } | undefined
  let dp;
  let telemetryTS = moment.utc()
  if (isServiceSuccess(val) && isOrionTelemetry(val.data) && isOrionTelemetryDataAvailable(val.data)) {
    let newMetSource: string = "NONE";
    for (let t of [["CITP_MET_Days", "days"], ["CITP_MET_Hours", "hours"], ["CITP_MET_Mins", "minutes"], ["CITP_MET_Secs", "seconds"]]) {
      dp = val.data.data.find((dp: OrionTelemetryDatapoint) => {
        return dp.name === t[0]
      })
      if (dp) {
        if (!constructedMET)
          constructedMET = {}
        newMetSource = "STANDARD"
        constructedMET[t[1]] = dp.value
      }
    }

    if (!dp) dp = val.data.data.find((value) => value.name === "UNCNF_MET");
    if (!dp) dp = val.data.data.find((value) => value.name === "UNCNF_MET_Orion");
    if (!dp) dp = val.data.data.find((value) => value.name === "UNCNF_MET_ICPS");

    // const newMET = val.data.data.find((value) => value.name === "UNCNF_MET")?.value;
    // console.log(newMET)
    // if (newMET && typeof newMET === 'string') this.met = newMET;

    if (dp && dp.time) {
      newMetSource = dp.name;
      telemetryTS = dp.time instanceof Date ? moment.utc(dp.time) : dpTimeToDate(dp.time)
      let newMET = moment.duration(constructedMET || { seconds: parseInt(typeof dp.value === 'number' ? dp.value.toFixed(0) : dp.value.toString()) })
      newMET.add(gmt.value.clone().subtract(telemetryTS.valueOf()).valueOf())
      met.value = newMET
    }
    metSource.value = newMetSource
  }
})

const timeline = computed<{ met: moment.Duration, name: string, description: string } | null>(() => {
  if (met.value) {
    if (isServiceSuccess(props.dataTimeline) && isArtemisTimeline(props.dataTimeline.data)) {
      const nextMilestone = props.dataTimeline.data.data.milestones.at(0)
      if (nextMilestone) {
        return {
          met: met.value.clone().subtract({ seconds: nextMilestone.time }),
          name: nextMilestone.title,
          description: nextMilestone.description,
        }
      }
      //   let event;
      //   let event_i = props.dataTimeline.data.events.findIndex((ev) => (met.value ? met.value.asMinutes() : 0) <= ev.metMinutes)

      //   if (
      //     (
      //       met.value.asMinutes() - (props.dataTimeline.data.events.at(event_i - 1)?.metMinutes || 0) < 2 * 60
      //     )
      //     && ((props.dataTimeline.data.events.at(event_i)?.metMinutes || 0) - (props.dataTimeline.data.events.at(event_i - 1)?.metMinutes || 0)) > 2 * 60
      //   ) {
      //     event = props.dataTimeline.data.events.at(event_i - 1)
      //   } else {
      //     event = props.dataTimeline.data.events.at(event_i)
      //   }
      //   return {
      //     met: met.value.clone().subtract(moment.duration({ minutes: event?.metMinutes })),
      //     ...event
      //   }
    }
  }
  return null
});

onMounted(() => {
  timer.value = setInterval(() => {
    gmt.value = moment.utc()

    if (metSource.value === "NONE" && met.value !== null) {
      met.value.add({ seconds: 1 })
    }
  }, 1000)
});

onUnmounted(() => {
  clearInterval(timer.value)
});

return { __sfc: true,timeMCC, durationMCC, props, gmt, met, metSource, timer, timeline }
}

})